import { useState, useEffect } from 'react';
import { useStore } from '../../store/store';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import IndiaPayment from '../../components/Payment/IndiaPayment';
import CryptoJS from 'crypto-js';
import '../../styles/global.scss';
import ThailandPayment from '../../components/Payment/ThailandPayment';

const { COUNTRY, PROVIDERS } = JSON.parse(process.env.REACT_APP_PAYMENT_CONFIG);
const Payment = () => {
  const { paymentData, setPaymentData } = useStore();
  const [payLoad, setPayload] = useState({});

  useEffect(() => {
    if (window.name) {
      try {
        console.log('Window name ', window.name);
        const bytes = CryptoJS.AES.decrypt(
          window.name,
          process.env.REACT_APP_SECRET_KEY
        );
        const decryptedStr = bytes.toString(CryptoJS.enc.Utf8);
        const data = JSON.parse(decryptedStr);
        setPayload(data);
        setPaymentData(data);
        console.log('Decrypted payload:', data);
        console.log('India', data.country);
        window.name = ''; // clear after use
      } catch (error) {
        console.error('Failed to decrypt window.name payload', error);
      }
    }
  }, []);

  useEffect(() => {
    console.log('Country', paymentData.country);
  }, [paymentData]);
  return (
    <div className="bg-white" style={{ width: '100%', position: 'relative' }}>
      <Header hideLoginButton={COUNTRY === 'TH'} />

      {COUNTRY === 'IND' && <IndiaPayment />}
      {COUNTRY === 'TH' && <ThailandPayment providers={PROVIDERS} />}
    </div>
  );
};

export default Payment;
